import React from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../../translation/namespace';
import { InteractionStatus } from '../../../../types/InteractionStatus';
import { FormResponseErrorType, FormUtils, InputType, useFormContext } from '../../../molecules/Form';
import FormInput from '../../../molecules/Form/components/FormInput/FormInput';
import FormsRow from '../../../molecules/Form/components/FormsRow/FormsRow';
import LiveRegion from '../../../atoms/LiveRegion/LiveRegion';
import { translatePartOfStringWithLink } from '../../../../lib/StringUtils/StringHTMLUtils';
import { useAppContext } from '../../../../contexts/AppContext/AppContext';
import { FormSubmitButton } from '../../../molecules/Form/components/FormSubmitButton/FormSubmitButton';

function UserRegistrationFormTemplate() {
  const { t } = useTranslation(Namespace.UserRegistration);
  const { portalConfiguration } = useAppContext();
  const { inputs, response, onChange, getStatus, submitActionEnabled } = useFormContext();

  const getStatusMessages = () => {
    return {
      [InteractionStatus.FAIL]: FormUtils.createStatusMessage(t('registerFail')),
      [InteractionStatus.SUCCESS]:
        response?.status === 200 && response?.data?.url
          ? FormUtils.createStatusMessage(t('registerExternal'))
          : FormUtils.createStatusMessage(t('registerSuccess')),
      [FormResponseErrorType.EMAIL_DOMAIN_NOT_ALLOWED]: FormUtils.createStatusMessage(
        translatePartOfStringWithLink(
          `${Namespace.Form}:errorType.${FormResponseErrorType.EMAIL_DOMAIN_NOT_ALLOWED}`,
          portalConfiguration.son_portal_support_email && `mailto:${portalConfiguration.son_portal_support_email}`,
        ),
      ),
    };
  };

  return (
    <>
      <h2 className="form__headline">{t('headline')}</h2>
      <FormsRow>
        <FormInput
          id="user-registration"
          name={inputs.email.name}
          type={InputType.EMAIL}
          labelTitle={t(`${Namespace.glossary}:eMailAddress`)}
          required={inputs.email.required}
          pattern={inputs.email.constraints.pattern}
          patternMismatchErrorMessage={t('emailNotValid')}
          maxLength={inputs.email.constraints.maxLength}
          // Events
          onChange={({ target }) => onChange(target.name, target.value)}
        />
      </FormsRow>
      <FormSubmitButton buttonLabel={t('sendRegistration')} enabled={submitActionEnabled()} />
      <LiveRegion invisible={false} htmlTag="div">
        {getStatus(getStatusMessages())}
      </LiveRegion>
    </>
  );
}

export default UserRegistrationFormTemplate;
